import { AdminLayout, useSource, useTranslation } from "@opendash/core";
import { AdminToolbar, FixedDescription } from "@opendash/ui";
import { Button, Card } from "antd";
import React, { useMemo, useState } from "react";
import {
  FileDescription,
  KnowledgeUploadModal,
  useSourceFiles,
} from "../../features/knowledge";
import { Media } from "../../js/parsegenerated";

export default () => {
  const t = useTranslation();
  const [source] = useSource();
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const { media, sourceFile, reload } = useSourceFiles(source?.id);

  function onCloseHanlder() {
    setUploadModalOpen(false);
    reload();
  }

  async function handleDelete(file: Media) {
    sourceFile.get("files").remove(file);
    await sourceFile.save();
    await file.destroy();
  }

  const fileList = useMemo(
    () =>
      media.map((file) => (
        <FileDescription
          fileData={file}
          key={file.id}
          showActions
          onDelete={() => handleDelete(file)}
        />
      )),
    [media]
  );

  return (
    <AdminLayout>
      <AdminToolbar
        title={t("maintenance:knowledge.admin.title", { source: source?.name })}
        actions={[
          <Button
            onClick={() => setUploadModalOpen(true)}
            key="0"
            type="primary"
          >
            {t("maintenance:knowledge.admin.upload.button.title")}
          </Button>,
        ]}
      />
      <Card>
        <FixedDescription>{fileList}</FixedDescription>
      </Card>
      <KnowledgeUploadModal open={uploadModalOpen} onClose={onCloseHanlder} />
    </AdminLayout>
  );
};
